// Maps a chat's agent/model to a short label + brand-ish colour for the list tag.
// The tag renders as coloured text on a 16% tint of the same colour, so it stays
// readable in both dark and light themes.
//
// C4 — declaration-driven: the colour comes from the agent PLUGIN's declared `ui.color`
// (served by /api/plugins), NOT a hardcoded per-agent map here. An agent that declares no
// colour falls back to a STABLE hash-derived hue (distinct + readable), so adding a new
// agent gives its tag its own colour with zero edits to this file (modularity audit frontend).
import type { Plugin } from '../api/client'

/** Deterministic, readable colour from an arbitrary key — so an UNDECLARED agent still gets a
 *  distinct tag instead of a single flat grey. Fixed S/L keeps it legible over the 16% tint. */
function hashColor(key: string): string {
  let h = 0
  for (let i = 0; i < key.length; i++) h = (Math.imul(h, 31) + key.charCodeAt(i)) >>> 0
  return `hsl(${h % 360} 52% 58%)`
}

export function agentTag(
  chat: { agent_plugin?: string | null; command?: string },
  plugins?: Plugin[],
): { label: string; color: string } {
  const raw =
    chat.agent_plugin ||
    (chat.command ? chat.command.trim().split(/\s+/)[0].split('/').pop() : '') ||
    'shell'
  const key = raw.toLowerCase()
  const declared = plugins?.find((p) => p.name.toLowerCase() === key)?.ui?.color
  return { label: key, color: declared ?? hashColor(key) }
}
